export default __webpack_public_path__ + "static/media/icon_back.c28a30bb.png";